import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Tile } from './tile.interface';

@Component({
  selector: 'tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.scss'],
})
export class TileComponent {
  @Input() tile: Tile;
  @Input() loading: boolean;

  @Output() tileClicked = new EventEmitter();
}
